import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Allocation, Position, Project, ProjectData } from '@app/core/models';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class FormToModelAdapter {
  static simulationFormToProject(
    simulationForm: UntypedFormGroup,
    creationDate: string,
    userId: string,
    projectData: ProjectData = {
      id: undefined,
      isArchived: false,
      missingAssets: false,
      missingFinancialProfile: false,
      missingRiskProfile: false,
      lastModified: undefined,
      backtestParameters: undefined,
      backtestResults: undefined,
    }
  ): Project {
    const creditRateValue = simulationForm.get('projectFormGroup').get('projectCreditRate').value;
    const creditRate = creditRateValue
      ? typeof creditRateValue === 'string'
        ? parseFloat(creditRateValue.replace(',', '.'))
        : creditRateValue
      : undefined;

    return {
      id: projectData.id,
      userId,
      name: `${simulationForm.get('projectFormGroup').get('projectName').value ?? ''}-${creationDate}`,
      currency: simulationForm.get('projectFormGroup').get('projectCurrency').value,
      creditRate: creditRate ? creditRate : 0,
      hedge: simulationForm.get('projectFormGroup').get('hedging').value === 'hedged',
      financialProfile: simulationForm.get('projectFormGroup').get('projectFinancialProfile').value,
      riskProfile: simulationForm.get('projectFormGroup').get('projectRiskProfile').value,
      missingAssets: projectData.missingAssets,
      missingFinancialProfile: projectData.missingFinancialProfile,
      missingRiskProfile: projectData.missingRiskProfile,
      lastModified: projectData.lastModified,
      isArchived: projectData.isArchived,
      allocations: (simulationForm.get('allocationsSetupFormArray') as UntypedFormArray).controls.map(
        (allocationControls, index) => this._allocationFormToAllocation(allocationControls as UntypedFormGroup, index)
      ),
      backtestParameters: projectData.backtestParameters,
      backtestResults: projectData.backtestResults,
    };
  }

  static getAllocationNameFromIndex(allocationIndex: number): string {
    return `Allocation ${allocationIndex + 1}`
  }

  private static _allocationFormToAllocation(
    allocationControls: UntypedFormGroup,
    allocationIndex: number
  ): Allocation {
    const positionsValue: Position[] = [];
    const controlsArray = Object.keys(allocationControls.controls);

    controlsArray.forEach(controlKey => {
      const value = allocationControls.controls[controlKey].value;
      if (value !== null && value !== 0) {
        positionsValue.push({ instrumentId: parseInt(controlKey, 10), positionValue: value });
      }
    });
    const allocation = {
      id: allocationIndex,
      name: FormToModelAdapter.getAllocationNameFromIndex(allocationIndex),
      positions: positionsValue,
    };
    return allocation;
  }
}


